var map = {
	"./BelumTumbuh.svg": "5296",
	"./Character.svg": "fedd",
	"./Cross.svg": "7714",
	"./CryingFace.svg": "2568",
	"./Ellipse.svg": "f2e0",
	"./EllipseFill.svg": "ca74",
	"./FrowningFace.svg": "f583",
	"./GeneralConsentIcon.svg": "e9f1",
	"./Goyang.svg": "c19e",
	"./HappyFace.svg": "56fb",
	"./HumanBody.svg": "4084",
	"./LOGO FIX PNG 1.svg": "9078",
	"./LOGO-Klinik-Pratama-PKU-Kertek.svg": "c60e",
	"./NeuroviLogoSVG.svg": "9742",
	"./NoExpressionFace.svg": "711c",
	"./OdontogramNew.svg": "2476",
	"./SmilingFace.svg": "a2ab",
	"./WorriedFace.svg": "58ae",
	"./account_add.svg": "26bc",
	"./account_close.svg": "0d10",
	"./account_journal.svg": "f87e",
	"./account_ledger.svg": "bf24",
	"./account_report.svg": "3a55",
	"./accounting.svg": "c888",
	"./avatar_placeholder.svg": "3272",
	"./background complete.svg": "cb64",
	"./bed-1.svg": "f6c1",
	"./bed-2.svg": "c79b",
	"./bed-3.svg": "0eeb",
	"./bed-4.svg": "b3f4",
	"./bed-icon.svg": "e59f",
	"./bed.svg": "3aaa",
	"./billing_assurance_report.svg": "d6fd",
	"./billing_cash_payment.svg": "b7f2",
	"./billing_history_report.svg": "f5b3",
	"./billing_income_report.svg": "bf38",
	"./billing_patient_bill.svg": "88b0",
	"./billing_report_bill.svg": "a51e",
	"./billing_setor_kas.svg": "506a",
	"./billing_summary.svg": "00e1",
	"./billing_verification_report.svg": "ccfd",
	"./billing_wadiah_report.svg": "3113",
	"./calculus.svg": "3a2d",
	"./calendar.svg": "cb90",
	"./checklist.svg": "22e5",
	"./circle.svg": "83c6",
	"./coin.svg": "bc21",
	"./dental-background.svg": "04fe",
	"./dental-calculus.svg": "167d",
	"./dental-radix.svg": "2ffa",
	"./dental-shaking.svg": "7a2b",
	"./dinkes.svg": "f0db",
	"./drug_hand.svg": "9e50",
	"./drug_pill.svg": "c4a7",
	"./drug_tablet.svg": "0b54",
	"./emoji_dying.svg": "9c86",
	"./emoji_flat.svg": "a883",
	"./emoji_happy.svg": "3ac4",
	"./emoji_panic.svg": "5b34",
	"./emoji_sad.svg": "e798",
	"./emoji_smile.svg": "14c3",
	"./finance.svg": "6e86",
	"./finance_aset.svg": "88fa",
	"./finance_hutang.svg": "fe35",
	"./finance_income.svg": "63c7",
	"./finance_kas.svg": "3594",
	"./finance_kas_bank.svg": "f87c",
	"./finance_persediaan.svg": "530e",
	"./finance_persetujuan.svg": "f1c5",
	"./finance_piutang.svg": "cca2",
	"./finance_rekap.svg": "02c1",
	"./finance_verification.svg": "6373",
	"./hospital.svg": "396a",
	"./illustration_billing-report.svg": "aee2",
	"./illustration_billing.svg": "126b",
	"./illustration_card_payment.svg": "3678",
	"./illustration_mortality.svg": "0066",
	"./letter.svg": "fe28",
	"./lines.svg": "958a",
	"./logo_bpjs.svg": "3d0f",
	"./mark_body_female_image.svg": "7725",
	"./mark_body_male_image.svg": "f9a7",
	"./mark_face_front_image.svg": "2efc",
	"./mark_face_side_image.svg": "b762",
	"./mark_foot_lower_image.svg": "ad23",
	"./mark_foot_upper_image.svg": "f7b1",
	"./mark_palm_lower_image.svg": "edc0",
	"./mark_palm_upper_image.svg": "2818",
	"./medicine.svg": "dc56",
	"./medicine_guide.svg": "3c57",
	"./memberReport_consulting.svg": "9b9b",
	"./memberReport_doctor.svg": "0645",
	"./memberReport_laying-patient.svg": "2828",
	"./memberReport_total.svg": "bd67",
	"./mjkn_reporting_icon.svg": "8e2a",
	"./monthly_report_graph.svg": "2b95",
	"./mortality_patient_death.svg": "5869",
	"./mortality_toddler_death.svg": "8bdb",
	"./over_the_counter.svg": "0028",
	"./pain-level-colored.svg": "26cb",
	"./pain-level.svg": "6afa",
	"./paper.svg": "c546",
	"./pharmacy_bookpill.svg": "b61d",
	"./pharmacy_bottle-pill.svg": "c6c6",
	"./pills.svg": "7e5a",
	"./plus.svg": "52d7",
	"./radix.svg": "a073",
	"./red_cross.svg": "719e",
	"./report-finance-imange.svg": "21ed",
	"./report_book.svg": "338e",
	"./report_building.svg": "e3d1",
	"./report_graphBPJS.svg": "9a51",
	"./report_graphic.svg": "d7b7",
	"./report_graphic2.svg": "13bd",
	"./report_stethoscope.svg": "6099",
	"./right-eye.svg": "5b7a",
	"./scientist.svg": "bad0",
	"./scissors.svg": "0d98",
	"./shadow.svg": "04ee",
	"./sign_warning.svg": "8255",
	"./stethoscope.svg": "deed",
	"./syringe.svg": "f01e",
	"./top_ten_drug_icon.svg": "5b0b",
	"./tv-24px.svg": "df4a",
	"./visit-igd.svg": "c43f",
	"./visit-inpatient.svg": "11b5",
	"./visit-outpatient.svg": "1824"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2739";